import { render } from "./recordList.vue?vue&type=template&id=2f4340e0&scoped=true"
import script from "./recordList.vue?vue&type=script&lang=js"
export * from "./recordList.vue?vue&type=script&lang=js"

import "./recordList.vue?vue&type=style&index=0&id=2f4340e0&lang=scss&scoped=true"

import exportComponent from "D:\\消防\\dashboard\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f4340e0"],['__file',"src/views/alfmeier/rank/recordList.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2f4340e0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2f4340e0', __exports__)) {
    console.log('reload')
    api.reload('2f4340e0', __exports__)
  }
  
  module.hot.accept("./recordList.vue?vue&type=template&id=2f4340e0&scoped=true", () => {
    console.log('re-render')
    api.rerender('2f4340e0', render)
  })

}


export default __exports__